import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function appidea() {
  return (
    <section className="app_amj p-100" style={{ background: "#F6F0E9" }}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className=" my-auto">
            <h2>Target Audience</h2>
            <p>
              Rodeo Social is tailored for businesses and teams seeking a
              streamlined social media management solution. It caters to
              startups and enterprises across diverse industries, offering a
              user-friendly interface for efficient content creation,
              scheduling, and posting. Ideal for content creators, marketers,
              and teams, Rodeo Social stands out as a collaborative hub.
            </p>
            <p>
              The app’s appeal extends to gamification enthusiasts, introducing
              a competitive edge to social media strategies. In essence, Rodeo
              Social targets businesses of all sizes, providing a modern,
              efficient, and engaging approach to social media management.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/rodeo/target-audience.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={685}
              height={747}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default appidea;
